import React from "react";
import { ListGroup, Nav, Overlay, Popover } from "react-bootstrap";
import { connect, DispatchProp } from "react-redux";
import NavigationUtility from "utilities/NavigationUtility";
import IStore from "models/IStore";
import IAction from "models/IAction";
import BaseButton from "views/components/base-form/BaseButton";
import IconNameEnum from "constants/IconNameEnum";
import RouteEnum from "constants/RouteEnum";
import NotificheAction from "stores/notifiche/NotificheAction";
import PreventiviInScadenzaModel from "stores/notifiche/models/PreventiviInScadenzaModel";
import PreventiviConFirmaDigitaleModel from "stores/notifiche/models/PreventiviConFirmaDigitaleModel";
import AppointmentModel from "stores/notifiche/models/AppointmentModel";
import { selectRequesting } from "selectors/requesting/RequestingSelector";

interface IProps {}

interface IState {
    readonly showAlert: boolean;
}

interface IStateToProps {
    readonly isLogged: boolean;
    readonly preventiviInScadenza: PreventiviInScadenzaModel[];
    readonly preventiviConFirmaDigitale: PreventiviConFirmaDigitaleModel[];
    readonly appointments: AppointmentModel[];
    readonly preventiviInScadenzaTotal: number;
    readonly preventiviConFirmaDigitaleTotal: number;
    readonly appointmentsTotal: number;
    readonly notificheTotal: number;
    readonly isRequesting: boolean;
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    isLogged: state.utente.profilo.isLogged,
    preventiviInScadenza: state.notifiche.preventiviInScadenza,
    preventiviConFirmaDigitale: state.notifiche.preventiviConFirmaDigitale,
    appointments: state.notifiche.appointments,
    preventiviInScadenzaTotal: state.notifiche.preventiviInScadenzaTotal,
    preventiviConFirmaDigitaleTotal: state.notifiche.preventiviConFirmaDigitaleTotal,
    appointmentsTotal: state.notifiche.appointmentsTotal,
    notificheTotal:
        state.notifiche.appointmentsTotal +
        state.notifiche.preventiviConFirmaDigitaleTotal +
        state.notifiche.preventiviInScadenzaTotal,
    isRequesting: selectRequesting(state, [
        NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_EXPIRING_ESTIMATE,
        NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_DIGITAL_SIGNED_DOCUMENTS,
    ]),
});

class HeaderNotifiche extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);
        this.state = {
            showAlert: false,
        } as IState;
    }

    private hasUnmounted = false;
    private container: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

    componentDidMount() {
        this.props.dispatch(NotificheAction.getTodayAppointments());
        this.props.dispatch(NotificheAction.getExpiringEstimateNotification());
        this.props.dispatch(NotificheAction.getDigitalSignedDocumentNotification());
    }

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private redirectToPage = (page: string) => {
        NavigationUtility.redirectToPage(page);
        this.toggleAlert(false);
    };

    private toggleAlert = (show: boolean, autoclose?: boolean) => {
        if (this.hasUnmounted === false) {
            this.setState({
                showAlert: show,
            });
            if (autoclose === true) {
                setTimeout(() => {
                    this.toggleAlert(false);
                }, 5000);
            }
        }
    };

    private handleVisualizzaNotifiche = () => {
        this.redirectToPage(RouteEnum.NOTIFICHE);
    };

    public render(): JSX.Element | null {
        const { showAlert } = this.state;
        const {
            preventiviInScadenzaTotal,
            preventiviConFirmaDigitaleTotal,
            appointmentsTotal,
            notificheTotal,
            isRequesting,
        } = this.props;

        return (
            <Nav>
                <div
                    ref={this.container}
                    className="px-3 margin-top border-right"
                    onMouseEnter={() => this.toggleAlert(true)}
                    onMouseLeave={() => this.toggleAlert(false)}
                >
                    <BaseButton
                        type="button"
                        color="none"
                        label={"Notifiche"}
                        icon={IconNameEnum.Notifiche}
                        iconPos="before"
                        iconBadge={notificheTotal !== 0 ? notificheTotal : ""}
                        className="notifiche"
                        bottomLabel={true}
                    />
                    <Overlay
                        show={notificheTotal !== 0 ? showAlert : false}
                        placement="bottom"
                        target={this.container}
                        rootClose={true}
                        onHide={() => this.toggleAlert(false)}
                    >
                        <Popover id="notifiche-popover" className="ocq-shadow">
                            <Popover.Title as="h5" className="text-center">
                                {"Riepilogo notifiche"}
                            </Popover.Title>
                            <Popover.Content>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="p-2 notificha-item">
                                        <span className="mr-2 bg-ocq-blue  badge badge-primary">
                                            {preventiviInScadenzaTotal}
                                        </span>
                                        Preventivi in scadenza
                                    </ListGroup.Item>
                                    <ListGroup.Item className="p-2 notificha-item">
                                        <span className="mr-2 bg-ocq-blue  badge badge-primary">
                                            {appointmentsTotal}
                                        </span>
                                        Prossimo appuntamento
                                    </ListGroup.Item>
                                    <ListGroup.Item className="p-2 notificha-item">
                                        <span className="mr-2 bg-ocq-blue badge badge-primary">
                                            {preventiviConFirmaDigitaleTotal}
                                        </span>
                                        Preventivi da finalizzare
                                    </ListGroup.Item>
                                    <div className="text-center">
                                        <hr className="mt-0" />
                                        <BaseButton
                                            type="button"
                                            color="blue"
                                            icon={IconNameEnum.Notifiche}
                                            label="Visualizza notifiche"
                                            onClickHandler={this.handleVisualizzaNotifiche}
                                            className="small"
                                        />
                                    </div>
                                </ListGroup>
                            </Popover.Content>
                        </Popover>
                    </Overlay>
                </div>
            </Nav>
        );
    }
}

export { HeaderNotifiche as Unconnected };
export default connect(mapStateToProps)(HeaderNotifiche);
